export const types = {
  'ISTJ': {
    name: '检查者',
    title: '严谨的执行者',
    description: '安静、严谨、负责任，注重传统和秩序。',
    strengths: ['组织能力强', '可靠', '注重细节', '勤奋', '务实'],
    weaknesses: ['过于保守', '不够灵活', '可能固执', '难以接受变化'],
    careers: ['会计师', '工程师', '审计师', '军警人员', '行政管理']
  },
  'ISFJ': {
    name: '守护者',
    title: '尽职的照顾者',
    description: '安静、友善、负责任，关心他人感受。',
    strengths: ['细心', '可靠', '有耐心', '善解人意', '实际'],
    weaknesses: ['过分在意他人', '不善表达', '难以拒绝', '过度担忧'],
    careers: ['护士', '教师', '社工', '行政助理', '客服']
  },
  'INFJ': {
    name: '咨询师',
    title: '富有洞察力的理想主义者',
    description: '有创意、富有洞察力，关注他人成长。',
    strengths: ['洞察力强', '创造力强', '理想主义', '有同理心', '有条理'],
    weaknesses: ['过度完美主义', '太过理想化', '情绪敏感', '难以放松'],
    careers: ['咨询师', '作家', '教师', '艺术家', '心理治疗师']
  },
  'INTJ': {
    name: '建筑师',
    title: '富有战略思维的规划者',
    description: '独立、创新、分析性强，追求完美和效率。',
    strengths: ['战略思维', '独立性强', '创新能力', '分析能力', '追求卓越'],
    weaknesses: ['过于完美主义', '情商较低', '不够灵活', '可能显得傲慢'],
    careers: ['科学家', '工程师', '策略分析师', '建筑师', '系统设计师']
  },
  'ISTP': {
    name: '工匠',
    title: '灵活的问题解决者',
    description: '冷静、灵活、实际，善于解决具体问题。',
    strengths: ['实践能力强', '灵活性高', '冷静理性', '独立性强', '善于应变'],
    weaknesses: ['不善表达', '可能冷漠', '难以承诺', '缺乏规划'],
    careers: ['技师', '工程师', '机械师', '运动员', '法医']
  },
  'ISFP': {
    name: '艺术家',
    title: '灵活的艺术家',
    description: '安静、友善、敏感，享受当下的艺术家。',
    strengths: ['艺术感强', '感知力强', '适应力强', '和善', '富有同情心'],
    weaknesses: ['过分谦逊', '不善规划', '情绪化', '难以做决定'],
    careers: ['艺术家', '设计师', '音乐家', '摄影师', '美容师']
  },
  'INFP': {
    name: '调停者',
    title: '理想主义的梦想家',
    description: '理想主义、富有创意，追求内心和谐。',
    strengths: ['创造力强', '同理心强', '适应力强', '理想主义', '忠于自我'],
    weaknesses: ['过于理想化', '情绪化', '不切实际', '难以决断'],
    careers: ['作家', '心理咨询师', '艺术家', '教师', '社工']
  },
  'INTP': {
    name: '逻辑学家',
    title: '创新的思考者',
    description: '逻辑性强、创新、独立，追求知识的探索者。',
    strengths: ['分析能力强', '创造力强', '逻辑性强', '独立思考', '适应力强'],
    weaknesses: ['过于理论化', '社交能力弱', '拖延', '不切实际'],
    careers: ['科学家', '程序员', '分析师', '研究员', '哲学家']
  },
  'ESTP': {
    name: '冒险家',
    title: '灵活的实干家',
    description: '灵活、务实、行动导向，喜欢解决具体问题。',
    strengths: ['适应力强', '行动力强', '解决问题能力强', '现实主义', '灵活'],
    weaknesses: ['容易冲动', '可能缺乏耐心', '不喜欢计划', '可能忽视他人感受'],
    careers: ['企业家', '销售', '运动员', '紧急救援', '谈判专家']
  },
  'ESFP': {
    name: '表演者',
    title: '活力四射的表演者',
    description: '热情、友好、随和，喜欢与人相处和享受生活。',
    strengths: ['乐观开朗', '适应力强', '实用性强', '善于交际', '富有同情心'],
    weaknesses: ['容易分心', '不喜欢计划', '可能过度娱乐', '难以长期专注'],
    careers: ['艺术表演', '销售', '公关', '旅游导游', '活动策划']
  },
  'ENFP': {
    name: '探险家',
    title: '充满热情的创新者',
    description: '热情洋溢、富有创造力，善于看到可能性，善于激励他人。',
    strengths: ['创造力强', '热情', '适应力强', '洞察力强', '激励他人'],
    weaknesses: ['注意力分散', '情绪化', '不切实际', '难以完成细节'],
    careers: ['创意总监', '作家', '培训师', '市场营销', '创业者']
  },
  'ENTP': {
    name: '辩论家',
    title: '创新的思想家',
    description: '聪明、好奇、善于辩论，喜欢智力挑战。',
    strengths: ['创新思维', '适应力强', '分析能力强', '解决问题能力强', '领导力'],
    weaknesses: ['争论好胜', '不切实际', '注意力分散', '不耐烦'],
    careers: ['企业家', '律师', '咨询顾问', '发明家', '策略师']
  },
  'ESTJ': {
    name: '管理者',
    title: '务实的管理者',
    description: '有组织、果断、注重效率，善于制定和执行计划。',
    strengths: ['组织能力强', '负责任', '实际可靠', '注重效率', '决断力强'],
    weaknesses: ['固执', '不够灵活', '可能过于专制', '情商有待提高'],
    careers: ['项目经理', '行政管理', '财务总监', '军警人员', '生产主管']
  },
  'ESFJ': {
    name: '主人公',
    title: '热心的照顾者',
    description: '友善、负责任、合作，重视和谐与人际关系。',
    strengths: ['善解人意', '组织能力强', '可靠', '热心助人', '注重细节'],
    weaknesses: ['过分在意他人看法', '难以接受批评', '可能过度保护', '情绪化'],
    careers: ['人力资源', '客户服务', '医护人员', '教师', '社工']
  },
  'ENFJ': {
    name: '教导者',
    title: '富有魅力的引导者',
    description: '热情、负责任，关心他人成长，善于激励他人。',
    strengths: ['领导力强', '同理心强', '沟通能力强', '组织能力强', '激励他人'],
    weaknesses: ['过分理想化', '过度牺牲自我', '过于敏感', '难以拒绝他人'],
    careers: ['教师', '培训师', '人力资源', '公益组织', '心理咨询']
  },
  'ENTJ': {
    name: '统帅',
    title: '果断的领导者',
    description: '果断、有魄力，善于制定战略和领导他人。',
    strengths: ['领导力强', '战略思维', '决断力强', '自信', '追求卓越'],
    weaknesses: ['可能专制', '不够体贴', '过于苛刻', '缺乏耐心'],
    careers: ['企业高管', '管理咨询', '创业者', '政治家', '投资银行家']
  }
}

export const typeRelations = {
  'ISTJ': {
    idealPartners: ['ESFP', 'ESTP'],
    goodPartners: ['ISFJ', 'ESTJ', 'ISTJ'],
    complementary: ['ENFP', 'ENTP'],
    // ... 其他关系定义
  },
  // ... 其他类型关系
} 